import React, { useState, useEffect } from "react";
import axios from "axios";

const ChocolateDrizzledPopcornRecipeComponent = ({
  addIngredientsToCart,
  nameOfIngredients,
}) => {
  const [message, setMessage] = useState("");
  const [allItems, setAllItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);

  useEffect(() => {
    // Fetch all items from your API
    axios
      .get(`${process.env.REACT_APP_BACKEND_API}/products`)
      .then((response) => {
        setAllItems(response.data);
      })
      .catch((error) => {
        console.error("Error fetching all items:", error);
      });
  }, []);

  useEffect(() => {
    if (nameOfIngredients && nameOfIngredients.length > 0) {
      const filtered = allItems.filter((item) =>
        nameOfIngredients.includes(item.product_name)
      );
      setFilteredItems(filtered);
    }
  }, [nameOfIngredients, allItems]);

  const handleAddToCartClick = () => {
    try {
      const newItemAddedToFood = [];
      if (addIngredientsToCart && filteredItems.length > 0) {
        filteredItems.forEach((product) => {
          const food = {
            name: product.product_name,
            image: product.product_image,
            id: product.product_id,
            length: 1,
          };
          newItemAddedToFood.push(food);
        });

        addIngredientsToCart(newItemAddedToFood);

        setMessage("Ingredients have been added to your cart.");
      } else {
        setMessage("No specific ingredients selected to add to the cart.");
      }
    } catch (error) {
      console.error("Error adding ingredients to cart:", error);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 dark:text-white p-4 shadow-md rounded-lg">
      <div className="grid grid-cols-2">
        <div>
          <h3 className="text-2xl font-extrabold mb-8 text-center">
            Chocolate Drizzled Popcorn
          </h3>
          <img
            src="https://www.thechunkychef.com/wp-content/uploads/2020/01/Chocolate-Covered-Popcorn-gift.jpg"
            alt="Chocolate Drizzled Popcorn"
            className="w-full h-60 object-contain"
          />
        </div>
        <div>
          <h3 className="text-xl font-bold mb-8">Ingredients</h3>
          <ul className="list-disc pl-6 mb-4">
            <li className="mb-4">10 cups popped popcorn</li>
            <li className="mb-4">1 cup semisweet chocolate chips</li>
            <li className="mb-4">1/4 cup white chocolate chips (optional)</li>
            <li className="mb-4">1 tablespoon vegetable oil</li>
            <li className="mb-4">Salt to taste</li>
          </ul>
        </div>
      </div>

      <div>
        <h3 className="text-xl font-bold mb-8">Directions</h3>
        <ol className="pl-6 mb-4">
          <li className="mb-4">
            <strong className="text-xl">Step 1:</strong> Line a baking sheet
            with parchment paper and spread the popped popcorn evenly on it.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 2:</strong> In a microwave-safe
            bowl, melt the semisweet chocolate chips and white chocolate chips
            (if using) with vegetable oil in 30-second intervals, stirring each
            time, until smooth.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 3:</strong> Drizzle the melted
            chocolate over the popcorn and immediately sprinkle with a pinch of
            salt.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 4:</strong> Let the chocolate
            drizzle cool and harden, which may take about 30 minutes at room
            temperature.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 5:</strong> Once the chocolate is
            set, break the popcorn into clusters and enjoy your Chocolate
            Drizzled Popcorn!
          </li>
        </ol>
      </div>

      <div className="flex justify-center">
        <button
          onClick={handleAddToCartClick}
          className="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-white rounded-lg bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-900"
        >
          Add All Ingredients To Cart
        </button>
      </div>

      {message && <p className="mt-4">{message}</p>}
    </div>
  );
};

export default ChocolateDrizzledPopcornRecipeComponent;
